'use client';
import { useParams } from 'next/navigation';
import { defaultLang, SUPPORTED } from "../../config/languages";
import { COMPARE_SECTION } from "../../config/compareSections";
import PageLayout from "../PageLayout";
import { useTranslation } from "react-i18next";
import VsLayout2 from './Layout2';

export default function Vs() {
  const { t } = useTranslation(['vs']);
  const { lang = defaultLang } = useParams();
  const activeLang = SUPPORTED.includes(lang) ? lang : defaultLang;
  const section = COMPARE_SECTION[activeLang] || 'compare';

  return (
    <PageLayout
      presentLikeHome
      title={t('pageTitle', { ns: 'vs' })}
      metaDescription={t('pageMetaDescription', { ns: 'vs' })}
      canonical={`https://www.adcast.app${activeLang === 'en' ? '' : '/' + activeLang}/${section}`}
    >
      <VsLayout2 />
    </PageLayout>
  );
}
